module.exports = "/packs/images/svg/drop_down~d34ca6a7270b975d6b0adf9712972312.svg";